:host {
  /* Overridable CSS vars set at navbar level */
  --z-index: var(--menu-dropdown-z-index);

  user-select: none;
}

.EcoSuiteNavbarMenu {
  --mobile-panel-z-index: 1;
  --default-navbar-height: 48px;
  --mobile-panel-width: 290px;
  --app-switcher-max-width: 750px;
  --app-switcher-max-height: 575px;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  &--desktop {
    position: relative;
  }

  &__dropdown {
    position: absolute;
    z-index: var(--z-index);
    background-color: var(--pdt-color-surface-popover);
    border-radius: 10px;
    min-width: 240px;
    max-width: 500px;
    padding: var(--pdt-space-50);
    box-shadow: var(--pdt-shadow-surface-popover);
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - var(--navbar-height, var(--default-navbar-height)) - var(--pdt-space-300));
    overflow: auto;

    /* Default (hidden) styles */
    opacity: 0;
    transform: scale(0.95);
    transform-origin: top right;

    :host(:dir(rtl)) & {
      transform-origin: top left;
    }

    pointer-events: none;
    visibility: hidden;
    transition: opacity .2s ease, transform .2s ease, visibility .2s;

    &--hidden {
      min-width: 0;
      width: 0;
      overflow: hidden;
    }
  }

  &--open {
    .EcoSuiteNavbarMenu__dropdown {
      opacity: 1;
      transform: scale(1);
      pointer-events: auto;
      visibility: visible;
    }
  }

  &--appSwitcher {
    .EcoSuiteNavbarMenu__dropdown {
      max-width: var(--app-switcher-max-width);
      width: min(var(--app-switcher-max-width), calc(100vw - var(--pdt-space-250)));
      max-height: var(--app-switcher-max-height);
      border: 1px solid var(--pdt-color-border-subtle);
      transform-origin: top left;

      :host(:dir(rtl)) & {
        transform-origin: top right;
      }

      padding: 0;
    }
  }

  &__mobilePanel {
    position: absolute;
    inset: 0;
    width: var(--mobile-panel-width);
    overflow: auto;
    opacity: 0;
    background-color: var(--pdt-color-surface);
    z-index: var(--mobile-panel-z-index);
    padding: 0 var(--pdt-space-100) var(--pdt-space-100);
    transform: translateX(var(--mobile-panel-width));
    pointer-events: none;
    transition-property: transform, opacity;
    transition-duration: .2s;
    transition-timing-function: ease;
    border-inline-start: 1px solid var(--pdt-color-border-subtle);

    :host(:dir(rtl)) & {
      transform: translateX(calc(var(--mobile-panel-width) * -1));
    }

    &--open {
      transform: translateX(0);
      opacity: 1;
      pointer-events: auto;
      transition-property: transform;

      :host(:dir(rtl)) & {
        transform: translateX(0);
      }
    }
  }

  &__backBtn {
    appearance: none;
    display: flex;
    align-items: center;
    gap: var(--pdt-space-50);
    border: 1px solid transparent;
    border-radius: var(--pdt-radius-100);
    outline: none;
    background-color: transparent;
    color: var(--pdt-color-text-link);
    font-size: var(--pdt-text-body-sm-font-size);
    font-family: inherit;
    padding: var(--pdt-space-100);
    margin-block: var(--pdt-space-50);
    margin-inline: calc(var(--pdt-space-100) * -1) 0;
    cursor: pointer;

    &:hover {
      color: var(--pdt-color-text-link-hovered);
    }

    &:focus-visible {
      border-color: var(--pdt-color-border-focused);
      box-shadow: var(--pdt-shadow-focus);
    }

    pwc-icon-shadow[icon="chevron-left"] {
      :host(:dir(rtl)) & {
        transform: scaleX(-1);
      }
    }
  }

  &--noHeader {
    eco-suite-navbar-menu-header {
      display: none;
    }
  }

  &__sentinelStart,
  &__sentinelEnd {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
    border: 0;
  }
}
